document.addEventListener('DOMContentLoaded', () => {
  const filterForm = document.getElementById('CollectionFiltersForm');
  const layout = document.querySelector('.collection-layout-wrapper');

  const hasFilters =
    filterForm &&
    filterForm.querySelector(
      '.filter-checkbox-list, .dynamic-price-range-canva-block, .dynamic-cat-nav, #SortBySelect'
    );

  if (!hasFilters) {
    if (layout) layout.classList.add('no-filters');

    document
      .querySelectorAll(
        '.mobile-filter-toggle-btn, .filter-drawer-overlay, .collection-filters-sidebar'
      )
      .forEach((element) => element.remove());
  }

  if (!filterForm) return;

  const productGrid = document.getElementById('HousiousProductGrid');

  const defaultCollectionUrl =
    filterForm.dataset.currentCollectionUrl || window.location.pathname;

  const SEE_MORE_LIMIT = 5;

  /*
   * ---------------------------------------------------------
   * 1. SHOPIFY NATIVE FILTER FORM
   * ---------------------------------------------------------
   */

  filterForm.method = 'get';
  filterForm.action = window.location.pathname;

  /*
   * The range sliders are visual controls.
   * Only the numeric inputs submit price parameters.
   *
   * This prevents duplicate filter.v.price.gte and
   * filter.v.price.lte parameters.
   */

  const rangeMinInput = filterForm.querySelector('.range-min');
  const rangeMaxInput = filterForm.querySelector('.range-max');

  if (rangeMinInput) {
    rangeMinInput.removeAttribute('name');
  }

  if (rangeMaxInput) {
    rangeMaxInput.removeAttribute('name');
  }

  /*
   * ---------------------------------------------------------
   * 2. PRODUCT CARD ORDER
   * ---------------------------------------------------------
   */

  function sortTaggedProductsFirst(grid) {
    if (!grid) return;

    const products = Array.from(grid.children);
    const tagged = [];
    const rest = [];

    products.forEach((product) => {
      (product.querySelector('.custom-product-card--tagged')
        ? tagged
        : rest
      ).push(product);
    });

    const sorted = tagged.concat(rest);

    /* already in order: touch nothing */
    if (sorted.every((element, index) => element === products[index])) return;

    const fragment = document.createDocumentFragment();
    sorted.forEach((element) => fragment.appendChild(element));
    grid.appendChild(fragment);
  }

  sortTaggedProductsFirst(productGrid);

  /*
   * ---------------------------------------------------------
   * 3. FILTER LIST SEE MORE / SEE LESS
   * ---------------------------------------------------------
   */

  function injectSeeMoreStyles() {
    if (document.getElementById('sf-see-more-styles')) return;

    const style = document.createElement('style');

    style.id = 'sf-see-more-styles';

    style.textContent = `
      .filter-checkbox-list li.sf-extra-hidden {
        display: none !important;
      }

      .sf-see-more-btn {
        display: inline-block;
        margin: 10px 0 0;
        padding: 0;
        border: 0;
        background: transparent;
        color: #721033;
        font-size: 12.5px;
        font-weight: 700;
        cursor: pointer;
        text-decoration: underline;
      }
    `;

    document.head.appendChild(style);
  }

  function initSeeMore() {
    injectSeeMoreStyles();

    filterForm.querySelectorAll('.filter-checkbox-list').forEach((list) => {
      if (list.closest('.custom-navigation-categories')) return;

      if (list.dataset.sfSeeMore === 'true') return;

      const items = Array.from(list.children).filter(
        (element) => element.tagName === 'LI'
      );

      if (items.length <= SEE_MORE_LIMIT) return;

      list.dataset.sfSeeMore = 'true';

      const extraItems = items.slice(SEE_MORE_LIMIT);

      let open = extraItems.some((item) =>
        item.querySelector('input:checked')
      );

      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'sf-see-more-btn';

      function render() {
        extraItems.forEach((item) => {
          item.classList.toggle('sf-extra-hidden', !open);
        });

        button.textContent = open
          ? 'See less'
          : `See more (${extraItems.length})`;

        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      button.addEventListener('click', () => {
        open = !open;
        render();
      });

      render();

      list.insertAdjacentElement('afterend', button);
    });
  }

  initSeeMore();

  /*
   * ---------------------------------------------------------
   * 4. NATIVE FILTER SUBMISSION
   * ---------------------------------------------------------
   */

  function submitFilters() {
    /*
     * Shopify receives the selected native filter parameters
     * through the URL.
     *
     * The browser reloads the collection page.
     * Shopify renders the filtered products on the server.
     */

    filterForm.submit();
  }

  filterForm.addEventListener('change', (event) => {
    const target = event.target;

    if (!target) return;

    /*
     * Category navigation is not a Shopify native filter.
     * Navigate to the selected collection instead.
     */

    if (target.matches('.dynamic-cat-nav')) {
      if (!target.checked) return;

      const collectionUrl = target.dataset.collectionUrl;

      if (collectionUrl) {
        window.location.assign(collectionUrl);
      }

      return;
    }

    /*
     * Native Shopify filters.
     */

    if (
      target.matches('.filter-checkbox-input') ||
      target.matches('input[name="filter.v.availability"]') ||
      target.matches('input[type="checkbox"]') ||
      target.id === 'SortBySelect'
    ) {
      submitFilters();
    }
  });

  /*
   * ---------------------------------------------------------
   * 5. CLEAR ALL FILTERS
   * ---------------------------------------------------------
   */

  document.addEventListener('click', (event) => {
    const clearButton = event.target.closest('#ClearAllFilters');

    if (!clearButton) return;

    event.preventDefault();

    const cleanUrl =
      window.location.pathname.includes('all-collections')
        ? '/collections/all'
        : defaultCollectionUrl;

    window.location.assign(cleanUrl);
  });

  /*
   * ---------------------------------------------------------
   * 6. PRICE RANGE SLIDER
   * ---------------------------------------------------------
   */

  function initPriceSlider() {
    const minRange = filterForm.querySelector('.range-min');
    const maxRange = filterForm.querySelector('.range-max');

    const minNumber = filterForm.querySelector('.dynamic-min-input');
    const maxNumber = filterForm.querySelector('.dynamic-max-input');

    const sliderTrack = filterForm.querySelector('.slider-track');

    if (!minRange || !maxRange || !sliderTrack) return;

    const getLimits = () => ({
      min: Number(minRange.min) || 0,
      max: Number(minRange.max) || 500
    });

    function getErrorElement(input) {
      if (!input) return null;

      let error = input.parentElement.querySelector(
        '.price-validation-error'
      );

      if (!error) {
        error = document.createElement('small');

        error.className = 'price-validation-error';

        error.style.cssText = `
          display: none;
          color: #d32f2f;
          font-size: 12px;
          margin-top: 4px;
        `;

        input.parentElement.appendChild(error);
      }

      return error;
    }

    function validatePriceRange(changedInput) {
      if (!minNumber || !maxNumber) return true;

      const minError = getErrorElement(minNumber);
      const maxError = getErrorElement(maxNumber);

      const { min, max } = getLimits();

      const minText = minNumber.value.trim();
      const maxText = maxNumber.value.trim();

      const minValue =
        minText === '' ? null : Number(minText);

      const maxValue =
        maxText === '' ? null : Number(maxText);

      let minMessage = '';
      let maxMessage = '';

      if (minValue !== null && !Number.isFinite(minValue)) {
        minMessage = 'Enter a valid minimum price';
      } else if (minValue !== null && minValue < min) {
        minMessage = `Enter a minimum price of at least ${min}`;
      } else if (minValue !== null && minValue > max) {
        minMessage = `Enter a minimum price below ${max}`;
      }

      if (maxValue !== null && !Number.isFinite(maxValue)) {
        maxMessage = 'Enter a valid maximum price';
      } else if (maxValue !== null && maxValue > max) {
        maxMessage = `Enter a maximum price below ${max}`;
      } else if (maxValue !== null && maxValue < min) {
        maxMessage = `Enter a maximum price of at least ${min}`;
      }

      if (
        !minMessage &&
        !maxMessage &&
        minValue !== null &&
        maxValue !== null &&
        minValue >= maxValue
      ) {
        if (changedInput === minNumber) {
          minMessage = 'Minimum price must be less than maximum price';
        } else {
          maxMessage = 'Maximum price must be greater than minimum price';
        }
      }

      minError.textContent = minMessage;
      minError.style.display = minMessage ? 'block' : 'none';

      maxError.textContent = maxMessage;
      maxError.style.display = maxMessage ? 'block' : 'none';

      minNumber.setAttribute(
        'aria-invalid',
        minMessage ? 'true' : 'false'
      );

      maxNumber.setAttribute(
        'aria-invalid',
        maxMessage ? 'true' : 'false'
      );

      return !minMessage && !maxMessage;
    }

    function updateSliderTrack() {
      const { min, max } = getLimits();

      const minValue = Number(minRange.value);
      const maxValue = Number(maxRange.value);

      const range = max - min;

      const visualMin = Math.min(minValue, maxValue);
      const visualMax = Math.max(minValue, maxValue);

      const left = range
        ? ((visualMin - min) / range) * 100
        : 0;

      const right = range
        ? ((visualMax - min) / range) * 100
        : 100;

      sliderTrack.style.left = `${left}%`;
      sliderTrack.style.right = `${100 - right}%`;
    }

    function applyPriceFilter(changedInput) {
      const { min, max } = getLimits();

      let minValue =
        minNumber && minNumber.value.trim() !== ''
          ? Number(minNumber.value)
          : min;

      let maxValue =
        maxNumber && maxNumber.value.trim() !== ''
          ? Number(maxNumber.value)
          : max;

      if (
        !Number.isFinite(minValue) ||
        !Number.isFinite(maxValue)
      ) {
        return;
      }

      if (!validatePriceRange(changedInput)) return;

      minValue = Math.max(min, Math.min(minValue, max));
      maxValue = Math.max(min, Math.min(maxValue, max));

      if (minValue >= maxValue) return;

      minRange.value = minValue;
      maxRange.value = maxValue;

      if (minNumber) minNumber.value = minValue;
      if (maxNumber) maxNumber.value = maxValue;

      updateSliderTrack();

      submitFilters();
    }

    /*
     * Range slider input events.
     */

    minRange.addEventListener('input', () => {
      if (Number(minRange.value) > Number(maxRange.value)) {
        minRange.value = maxRange.value;
      }

      if (minNumber) {
        minNumber.value = minRange.value;
      }

      updateSliderTrack();
    });

    maxRange.addEventListener('input', () => {
      if (Number(maxRange.value) < Number(minRange.value)) {
        maxRange.value = minRange.value;
      }

      if (maxNumber) {
        maxNumber.value = maxRange.value;
      }

      updateSliderTrack();
    });

    minRange.addEventListener('change', () => {
      applyPriceFilter(minNumber);
    });

    maxRange.addEventListener('change', () => {
      applyPriceFilter(maxNumber);
    });

    /*
     * Numeric price input events.
     */

    [minNumber, maxNumber].forEach((input) => {
      if (!input) return;

      input.addEventListener('input', () => {
        const valid = validatePriceRange(input);

        if (input.value.trim() === '') return;

        const value = Number(input.value);

        if (!Number.isFinite(value)) return;

        const { min, max } = getLimits();

        const clampedValue = Math.max(
          min,
          Math.min(value, max)
        );

        if (input === minNumber) {
          minRange.value = clampedValue;
        } else {
          maxRange.value = clampedValue;
        }

        updateSliderTrack();

        if (!valid) return;
      });

      input.addEventListener('change', () => {
        applyPriceFilter(input);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          applyPriceFilter(input);
        }
      });
    });

    updateSliderTrack();
  }

  initPriceSlider();

  /*
   * ---------------------------------------------------------
   * 7. MOBILE FILTER DRAWER
   * ---------------------------------------------------------
   */

  document.body.addEventListener('click', (event) => {
    const sidebar = document.querySelector(
      '.collection-filters-sidebar'
    );

    const overlay = document.querySelector(
      '.filter-drawer-overlay'
    );

    if (event.target.closest('.mobile-filter-toggle-btn')) {
      sidebar?.classList.add('drawer-open');
      overlay?.classList.add('active');
    }

    if (event.target.classList.contains('filter-drawer-overlay')) {
      sidebar?.classList.remove('drawer-open');
      overlay?.classList.remove('active');
    }

    if (event.target.closest('#MobileFilterCloseBtn')) {
      sidebar?.classList.remove('drawer-open');
      overlay?.classList.remove('active');
    }
  });

  /*
   * ---------------------------------------------------------
   * 8. PRODUCT CARD IMAGE SLIDER
   * ---------------------------------------------------------
   */

  function sfSlide(media, direction, index) {
    if (!media) return;

    const slides = Array.from(
      media.querySelectorAll('[data-product-slide]')
    );

    const dots = Array.from(
      media.querySelectorAll('[data-slider-dot]')
    );

    if (slides.length < 2) return;

    const current = slides.findIndex((slide) =>
      slide.classList.contains('is-active')
    );

    const next =
      index != null
        ? index
        : (current + direction + slides.length) % slides.length;

    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === next);
    });

    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === next);
    });
  }

  document.body.addEventListener('click', (event) => {
    const control = event.target.closest(
      '[data-slider-prev], [data-slider-next], [data-slider-dot]'
    );

    if (!control) return;

    const card = control.closest('.custom-product-card');
    if (!card) return;

    const media = card.querySelector('[data-product-slider]');

    event.preventDefault();

    if (control.matches('[data-slider-prev]')) {
      sfSlide(media, -1);
    } else if (control.matches('[data-slider-next]')) {
      sfSlide(media, 1);
    } else {
      sfSlide(media, 0, parseInt(control.dataset.sliderDot, 10));
    }
  });
});